var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBoomlocalForward = function SvgBoomlocalForward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "boomlocal-forward_svg2__a",
    x1: 56.2,
    x2: 141.47,
    y1: 160.31,
    y2: 63.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#boomlocal-forward_svg2__a",
    id: "boomlocal-forward_svg2__b",
    x1: 34.32,
    x2: 119.59,
    y1: 141.1,
    y2: 43.97
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#boomlocal-forward_svg2__a",
    id: "boomlocal-forward_svg2__c",
    x1: 56.56,
    x2: 141.83,
    y1: 161.95,
    y2: 64.82
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "118---Forward"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.32 54.87a6.906 6.906 0 0 0-9.63-1.07 6.89 6.89 0 0 0-1.19 9.61 74.96 74.96 0 0 1 16.3 46.97c0 40.71-32.14 74.16-72.81 75.77-40.68 1.61-75.36-29.2-78.57-69.78-3.2-40.58 26.22-76.45 66.64-81.25l-9.33 8c-2.78 2.5-3.05 6.76-.62 9.6s6.68 3.22 9.58.87l24.12-20.67c1.53-1.31 2.41-3.22 2.41-5.23s-.88-3.92-2.41-5.23L90.7 1.78a6.89 6.89 0 0 0-6.85-1.4 6.9 6.9 0 0 0-4.55 5.31c-.44 2.47.5 4.98 2.44 6.55l10.4 8.91c-48.27 4.26-84.42 46.13-81.58 94.51s43.63 85.73 92.07 84.3 86.97-41.11 86.96-89.57a88.7 88.7 0 0 0-19.27-55.52",
    style: {
      fill: "url(#boomlocal-forward_svg2__a)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.78 52.84a6.89 6.89 0 0 0 4.71 2.39c1.82.14 3.63-.45 5.02-1.64l24.12-20.67c1.53-1.31 2.41-3.22 2.41-5.23s-.88-3.92-2.41-5.23L135.5 1.77a6.89 6.89 0 0 0-6.85-1.4 6.9 6.9 0 0 0-4.55 5.31c-.44 2.47.5 4.98 2.44 6.55l18 15.45-18.01 15.44a6.88 6.88 0 0 0-.75 9.71Z",
    "data-name": "Shape",
    style: {
      strokeWidth: 0,
      fill: "url(#boomlocal-forward_svg2__b)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M110.93 106.98c-.23-.41-.36-.71-.54-.98-2.11-3.11-4.24-6.2-6.32-9.33-.18-.27-.16-.92.04-1.15 4.26-4.97 9.05-9.26 15.3-11.6 4.46-1.67 9.07-2.3 13.83-1.85 8.1.75 14.92 4.08 20.32 10.18 3.71 4.19 6.03 9.09 6.97 14.62 1.51 8.97-.38 17.13-5.98 24.32-4.54 5.83-10.46 9.62-17.73 11.07-12.12 2.42-22.08-1.69-30.39-10.44-5.24-5.51-8.99-12.08-13.04-18.44-2.97-4.67-5.95-9.35-9.94-13.26-2.7-2.65-5.74-4.74-9.53-5.5-7.06-1.42-13.17.35-18.09 5.67-3.09 3.34-4.63 7.42-4.67 11.94-.08 7.77 4.39 14.97 12.35 17.54 7.14 2.3 13.44.67 18.84-4.37 2.16-2.02 4.01-4.39 5.95-6.64.83-.96.93-.95 1.61.13a345 345 0 0 0 5.78 8.86c.54.8.61 1.29-.08 2.07-3.05 3.39-6.32 6.51-10.26 8.85-6 3.56-12.48 4.84-19.4 4.07-5.88-.65-11.15-2.78-15.75-6.49-5.27-4.25-8.66-9.7-10.32-16.26-.97-3.86-1.16-7.77-.62-11.67.86-6.26 3.46-11.76 7.75-16.43 4.26-4.64 9.48-7.71 15.59-9.16 4.16-.99 8.37-1.05 12.62-.24 8.65 1.66 15.2 6.56 20.67 13.18 3.97 4.81 7.14 10.16 10.47 15.41 2.81 4.43 5.64 8.85 9.23 12.72 4.01 4.32 8.77 7.02 14.81 7 8.24-.03 15.3-5.21 17.65-13.12 2.49-8.34-.95-17.19-8.56-21.31-7.36-3.98-16.48-2.62-22.38 3.37-1.9 1.93-3.54 4.11-5.3 6.18-.2.24-.4.48-.86 1.06Z",
    style: {
      strokeWidth: 0,
      fill: "url(#boomlocal-forward_svg2__c)"
    }
  }));
};
export default SvgBoomlocalForward;